import { useMutation } from '@tanstack/react-query';

// Services
import { postResetFilters } from './resetFiltersService';

/**
 * Reset filters mutation (table or global)
 * @param {import('@tanstack/react-query').UseMutationOptions<void, Error, { path: string, type: 'tableFilters' | 'globalFilters' }, unknown>} [options = {}] - The mutation options
 * @returns {import('@tanstack/react-query').UseMutationResult<void, Error, { path: string, type: 'tableFilters' | 'globalFilters' }, unknown>}
 */
export const useResetFiltersMutation = (options = {}) => useMutation({
  mutationFn: ({ path, type }) => postResetFilters(path, type),
  ...options,
});
